module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "head_label"
  }, [_vm._v("Логотип")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": _vm.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "logo-input"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "logo"
    }
  }, [_vm._v("ИЗМЕНИТЬ")]), _vm._v(" "), _c('div', {
    staticClass: "fileform"
  }, [_c('div', {
    staticClass: "selectbutton"
  }, [_vm._v("Открыть")]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "upload",
      "type": "file",
      "name": "logo_upload"
    },
    on: {
      "change": _vm.onFileChange
    }
  }), _vm._v("\n            " + _vm._s(_vm.name) + "\n            "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "logo"
    },
    domProps: {
      "value": _vm.image
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeImage
    }
  }, [_vm._v("Удалить")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-e9761a48", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e9761a48"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/SalonFormImage.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-e9761a48"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/SalonFormImage.vue
// module chunks = 0